<template>
  <portal to="modals" v-if="show">
    <transition name="bbFade" @after-enter="showContent = true" appear>
      <div class="modal modal--plugin" v-show="show" @click="dismiss()" data-component="ModalDialogExternalEcommerce">
        <transition name="bbUp" @after-leave="dismiss()" appear>
          <div
            class="modal__card"
            :class="targetClass + ' ' + (hasFooter ? 'modal__card--with-footer' : '')"
            v-show="showContent"
            @click.stop=""
          >
            <div class="modal__dialog">
              <div class="modal__header" ref="modalHeader">
                <div class="modal__back">
                  <div v-show="back" class="modal-back">
                    <a @click.prevent="$emit('back')">
                      <div class="modal-back__name">
                        <img
                          src="../../../../assets/img/ico/ico-arrow-back.svg"
                          loading="lazy"
                          alt="Volver"
                          class="back__arrow"
                        />
                      </div>
                    </a>
                  </div>
                </div>
                <div class="bb-container" v-if="showHeader">
                  <div class="modal__logo" v-show="logoUrl">
                    <img
                      :src="logoUrl"
                      alt="Logo"
                    />
                  </div>

                  <div class="modal__logout" v-if="user && showLogout">
                    <a @click="$emit('logout')" class="link link--underline">
                      {{ $t("header.logOut") }}
                    </a>
                  </div>

                  <div class="modal__logout" v-else-if="showLogin">
                    <span>{{ $t("signup.alreadyHaveAnAccount", lang) }}</span>
                    <a @click.prevent="$emit('goToLogin')" style="cursor: pointer;" class="link link--underline">
                      {{ $t("signup.login", lang) }}
                    </a>
                  </div>

                  <div class="modal__logout" v-else-if="showSignup">
                    <span>{{ $t("login.notYet", lang) }}</span>
                    <a @click.prevent="$emit('goToSignup')" style="cursor: pointer;" class="link link--underline">
                      {{ $t("login.getItNow", lang) }}
                    </a>
                  </div>
                </div>
                <div class="modal__close">
                  <img
                    src="../../../../assets/img/ico/ico-close.svg"
                    alt="Cerrar"
                    @click="close()"
                  />
                </div>
              </div>
              <div class="modal__content" :style="contentStyle" ref="modalContent">
                <slot></slot>
              </div>
              <div class="modal__footer" v-if="hasFooter">

                <div class="cta-contributions" v-if="footer === 'contributions'">
                  <h3 class="cta-contributions__title">
                    {{ $t("mylist.share.enablePiggybank") }}
                  </h3>
                  <div class="cta-contributions__content">
                    {{ $t("mylist.share.enablePiggybankDescription") }}
                  </div>

                  <div class="cta-contributions__actions">
                    <button class="button button--accent" @click="goToPiggybank()">
                      {{ $t("mylist.share.enablePiggybankButton") }}
                    </button>

                    <a href="/mi-hucha/crear#comoFunciona">
                      {{ $t("mylist.share.howItWorkds") }}
                    </a>
                  </div>
                </div>

                <div class="bba-banner" v-if="footer === 'adsense'">
                  <div class="bba-banner__header">
                    <strong>Publicidad</strong>
                    <span class="link link--underline" @click="upgradeToPremium">Quitar publicidad</span>
                  </div>
                  <div class="bba-banner__main">
                    <Adsense :adType="adType" />
                  </div>
                </div>

              </div>
            </div>
          </div>
        </transition>
      </div>
    </transition>
  </portal>
</template>

<script>
function is_server() {
  return !(typeof window != "undefined" && window.document);
}

import { mapGetters } from "vuex";
import Adsense, { TYPE_IMAGE_SIDE } from "../../../adsense/Adsense";

export default {
  components: {
    Adsense,
  },
  props: {
    show: {
      type: Boolean,
      required: true,
    },
    back: {
      type: Boolean,
      default: false,
    },
    targetClass: {
      type: String,
      default: "",
    },
    showContributionsFooter: {
      type: Boolean,
      default: false,
    },
    showAdsenseFooter: {
      type: Boolean,
      default: false,
    },
    logoUrl: {
      type: String,
      default: "",
    },
    showLogout: {
      type: Boolean,
      default: true,
    },
    showLogin: {
      type: Boolean,
      default: false,
    },
    showSignup: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      showContent: false,
      adType: TYPE_IMAGE_SIDE,
      contentStyle: {},
      headerResizeObserver: null,
    };
  },
  computed: {
    ...mapGetters({
      hidePiggyBank: "hidePiggyBank",
      user: "user",
    }),
    lang() {
      return this.$i18n.locale;
    },
    footer() {
      if (this.showAdsenseFooter) {
        return "adsense";
      }
      if (this.showContributionsFooter && !this.hidePiggyBank) {
        return "contributions";
      }
      return null;
    },
    hasFooter() {
      return !!this.footer;
    },
    showHeader() {
      return !!this.logoUrl || this.showLogout || this.showLogin || this.showSignup;
    },
  },
  methods: {
    dismiss() {
      this.$emit("close");
    },
    close() {
      document.body.classList.remove("modal-open");
      this.$store.commit("toggleLandbot", true);
      //if route name is 'constructor-product' then go back to the previous page
      if (this.$route.name === "constructor-product") {
        this.$router.go(-1);
      } else {
        this.showContent = false
      }
    },
    upgradeToPremium() {
      return this.$store.dispatch("upgradeToPremium");
    },
    goToPiggybank() {
      if(this.$utils.isApp()) location.href = process.env.APP_URL + "mi-hucha/crear";
      else this.$router.push({ name: 'hucha-crear' })
    },
    updateModalContentStyle() {
      const minHeaderHeight = this.logoUrl ? 40 : 0;
      let marginTop = minHeaderHeight;

      const headerElement = this.$refs.modalHeader;
      console.log({ headerElement });
      if (headerElement) {
        const currentHeaderHeight = headerElement.getBoundingClientRect().height;
        console.log({ currentHeaderHeight });
        marginTop = Math.max(minHeaderHeight, currentHeaderHeight);
      }

      this.contentStyle = {
        marginTop: `${marginTop}px`,
      };
    },
    updateStyles() {
      this.updateModalContentStyle();
    },
  },
  created() {
    const escapeHandler = (e) => {
      if (e.key === "Escape" && this.show) {
        this.dismiss();
      }
    };
    const resizeHandler = (e) => {
      this.updateStyles();
    };

    if (!is_server()) {
      document.addEventListener("keydown", escapeHandler);
      document.addEventListener("resize", resizeHandler);
      this.headerResizeObserver = new ResizeObserver(() => {
        this.updateStyles();
      });
    }

    this.$once("hook:destroyed", () => {
      if (!is_server()) {
        document.removeEventListener("keydown", escapeHandler);
        document.removeEventListener("resize", resizeHandler);

        this.headerResizeObserver.disconnect();
      }
    });
    this.$watch(
      () => this.show,
      (show) => {
        if (show) {
          this.$store.commit("toggleLandbot", false);
          if (typeof document !== 'undefined') document.body.classList.add("modal-open");
        } else {
          this.$store.commit("toggleLandbot", true);
          if (typeof document !== 'undefined') document.body.classList.remove("modal-open");
        }
      },
      { immediate: true }
    );
  },
  mounted() {
    const stopAfter = Date.now() + 60_000;

    // Workaround.
    //
    // There must be a better way to detect when `this.$refs.modalHeader`
    // becomes available.
    //
    // `this.$watch` didn't seem to work.
    function tick() {
      if (Date.now() >= stopAfter) {
        console.log("Could not find header. Can't detect height.");
        this.updateStyles();

        return;
      }

      const el = this.$refs.modalHeader;

      if (!el) {
        setTimeout(() => {
          this.$nextTick(() => {
            tick.bind(this)();
          });
        }, 100);

        return;
      }

      this.headerResizeObserver.observe(el);
      this.updateStyles();
    };

    tick.bind(this)();
  },
};
</script>
